import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Footer from "../Components/Footer.js";
import HomeNavbar from "../HomeNavbar.js";
import StatsBox from "../Components/StatsPage/StatsBox.js";
import ResultInfoText from "../Components/ResultsTable/ResultInfoText.js";
import axios from "../api/axios.js";
import ErrorMessage from "../Components/RecordPage/ErrorMessage.js";

function VerificationPage() {
    const { token } = useParams();
    const [status, setStatus] = useState('verifying');

    const navigate = useNavigate();


    if (!token) {
    return (

        <div id="statsbody">
            <HomeNavbar />
            <div id="basicpage">
                <StatsBox title={<ResultInfoText text="Verify your email" row={1} fontSize="30px" buttonClass="plane-text-button-no-background"/>}>
                    <p>An email has been sent to your email address. Please click the link inside to verify your account.</p>
                    <p>If you do not see the email in your inbox, please check spam.</p>
                </StatsBox>
            </div>
            <Footer />
        </div>
    );}
    else{
        axios.get("/verify?token=" + token).then((res) => {
        if (res.status === 200) navigate("/login", { replace: false });
      }).catch((err) => {
        console.log(err);
        setStatus('error');
      });}
  if (status === 'verifying') {
    return(<div id="statsbody">
      <HomeNavbar />
      <div id="basicpage">
          <StatsBox title={<ResultInfoText text="Verification" row={1} fontSize="30px" buttonClass="plane-text-button-no-background"/>}>
              <p>Your email is being verified...</p>
          </StatsBox>
      </div>
      <Footer />
  </div>);
  }
  else if (status === 'error') {
    return (
      <div id="statsbody">
      <HomeNavbar />
      <div id="basicpage">
        <ErrorMessage
          title="Verification failed"
          message="The provided token is invalid or expired."
        />
      </div>
      <Footer />
    </div>
    );
  }

}

export default VerificationPage;